<template>
<div class="accountSite" v-if="memberOnly()">
    <h1>แอคเค้าท์</h1>
    <v-card>
        <v-tabs background-color="white" center-active centered>
            <v-tab :to="{name:'Account',params:{slug:'profile'}}">โปรไฟล์</v-tab>
            <v-tab :to="{name:'Account',params:{slug:'historyPoint'}}">ประวัติคะแนน</v-tab>
            <v-tab :to="{name:'Account',params:{slug:'historyTest'}}">ประวัติการสอบ</v-tab>
            <v-tab :to="{name:'Account',params:{slug:'historyLogin'}}">ประวัติการเข้าระบบ</v-tab>
            <v-tab disabled>แลกของรางวัล</v-tab>
            <v-tab :to="{name:'Account',params:{slug:'changePassword'}}">เปลี่ยนรหัสผ่าน</v-tab>

        </v-tabs>
    </v-card>

    <div class="mt-5">

        <AccountProfile v-if="slug=='profile'" />
         <ChangePassword v-if="slug=='changePassword'" />
         <HistoryLogin v-if="slug=='historyLogin'" />
         <HistoryTest v-if="slug=='historyTest'" />
         <HistoryPoint v-if="slug=='historyPoint'" />
    </div>

</div>
</template>

<script>
import HistoryLogin from '@/views/Account/HistoryLogin'
import AccountProfile from '@/views/Account/AccountProfile'
import ChangePassword from '@/views/Account/ChangePassword'
import HistoryTest from '@/views/Account/HistoryTest'
import HistoryPoint from '@/views/Account/HistoryPoint'
export default {

    components: {
        AccountProfile,
        HistoryLogin,
        HistoryTest,
        HistoryPoint,
        ChangePassword
    },

    data: () => ({

    }),

    methods: {

    },
    created() {

    },
};
</script>
